import type { SegmentedControlOptionInterface } from '@vkontakte/vkui';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { ISharingNewDialogProps } from './SharingNewSharing.types';

export const renderDeleteUsersDialog = (props: ISharingNewDialogProps) => {
    const { onActionClick } = props;

    openPopupHelper({
        popupName: popupNames.NO_WARNING,
        data: {
            id: 'sharing-warning-dialog',
            onActionClick,
            title: 'Вы действительно хотите отключить доступ для пользователей Облака?',
            description: 'После отключения эта папка перестанет быть доступной для приглашённых вами пользователей Облака',
            buttonAcceptText: 'Отключить',
            buttonRejectText: 'Не отключать',
        },
    });
};

export enum EPersonalSharingMode {
    link = 'link',
    mount = 'mount',
}

export const PERSONAL_SHARING_OPTIONS: SegmentedControlOptionInterface[] = [
    {
        label: 'По ссылке',
        value: EPersonalSharingMode.link,
    },
    {
        label: 'С интеграцией в Диск',
        value: EPersonalSharingMode.mount,
    },
];
